import MojitoServices from 'mojito/services';
import { INCREASE_KEYS } from 'modules/keypad/types.js';
import MojitoPresentation from 'mojito/presentation';
import KeyCodes from 'modules/keypad/key-codes.js';
import ClassNames from 'modules/keypad/class-names.js';
import { useSelector } from 'react-redux';

const CurrencyHelper = MojitoPresentation.Utils.CurrencyHelper;
const { selectCurrency } = MojitoServices.UserInfo.selectors;
const { FlexPane, Button } = MojitoPresentation.Components;

export default function IncrementalNumericKeypad(props) {
    const {
        mojitoTools: { stringResolver, config, style },
    } = props;
    const currencyCode = useSelector(state => selectCurrency(state));

    const onClick = (event, data) => {
        event.nativeEvent.stopImmediatePropagation();
        props.onClick(data);
    };

    const renderButton = ({ styleConfig, value, clickData, taClass }) => {
        return (
            <Button
                config={styleConfig}
                onClickData={clickData}
                onClick={onClick}
                class={`${ClassNames.KEYPAD_BUTTON} ${taClass}`}
            >
                {value}
            </Button>
        );
    };

    const renderIncreaseKey = name => {
        const configValue = config.increaseButtons.values[name];

        if (!configValue) {
            return null;
        }

        const clickData = { type: KeyCodes.INCREMENT, value: configValue, keyName: name };
        const styleConfig = style.increaseButtons[name];
        const value = stringResolver.resolveAndFormatString(
            '$INCREMENTAL_NUMERIC_KEYPAD.INCREASE_KEY',
            config.showCurrencySymbol
                ? CurrencyHelper.formatCurrencyWithSpecificOptions(configValue, currencyCode, {
                      minimumFractionDigits: 0,
                  })
                : configValue
        );

        return renderButton({ styleConfig, value, clickData, taClass: `ta-inckey-${name}` });
    };

    return (
        <FlexPane config={style.container}>
            {renderIncreaseKey('key4')}
            {renderIncreaseKey('key3')}
            {renderIncreaseKey('key2')}
            {renderIncreaseKey('key1')}
        </FlexPane>
    );
}

IncrementalNumericKeypad.getStyle = (config, mode, merge) => {
    const style = {};

    style.increaseButtons = INCREASE_KEYS.reduce((buttons, keyName) => {
        buttons[keyName] = merge(
            config.increaseButtons.default,
            config.increaseButtons.values[keyName]
        );
        return buttons;
    }, {});

    return merge(config, style);
};
